import { GradientRoot } from './GradientRoot'
import { useGradient } from './useGradient'

export const Gradient = {
  Root: GradientRoot,
  store: useGradient,
}
